import { ref } from "vue";
import { message, TreeProps } from "ant-design-vue";
import { QueryOrgs, QueryUsersByOrgId } from "../servers/userSelServer";
import { afterLoadUser, deepClone } from "../utils";
import GoingUtils from "@/utils/goingUtils";
import { QueryOrgByAccountId } from "@/components/select-org-ctl/servers/userSelServer";
import {initTreeData} from "xmgoing-utils";
import { useI18n } from "vue-i18n";

export function useOrgSel(alreadySelUsers) {
  const { t } = useI18n();
  //展开keys
  const expandedKeys = ref<string[]>([]);
  //机构树
  const orgTreeList: any = ref<TreeProps["treeData"]>([]);
  //查询用户列表集合
  const searchUserList = ref([]);
  const total=ref(0);
  const currentVal=ref(1);
  const pageSize=ref(20);
  const selectedKeysVal=ref(null);

  /**
   * 刷新组织机构列表
   */
  const flusOrgList = () => {
    QueryOrgs({}, (res) => {
      if (res) {
        orgTreeList.value = initTreeData(deepClone(res), unref(expandedKeys));
      }
    });
  };

  /**
   * 选择组织架构查询用户
   * @param selectedKeys
   */
  const selectOrg = (selectedKeys, { fromPagination = false } = {}) => {
    selectedKeysVal.value=selectedKeys;
    if (selectedKeys.length === 0) {
      return afterLoadUser({ records: [] }, alreadySelUsers, searchUserList);
    }

    if (!fromPagination) {
      currentVal.value = 1;
    }

    GoingUtils.showLoading();
    unref(searchUserList).splice(0, 1500);
    const parans={orgId:selectedKeys,size:unref(pageSize),current:unref(currentVal)};
    QueryUsersByOrgId(parans, (res) => {
      if(res.total){
        total.value=res.total;
      }else{
        total.value=searchUserList.value.length;
      }
      GoingUtils.closeLoading();
      afterLoadUser(res, alreadySelUsers, searchUserList);

    });
  };


  const onShowSizeChange=({current, pageSizeNum})=>{
    const keys = unref(selectedKeysVal);
    if (!keys || keys.length === 0) {
      message.warning(t('请选择组织'));
      return;
    }
    currentVal.value=current;
    pageSize.value=pageSizeNum;
    nextTick(()=>{
      selectOrg(unref(selectedKeysVal), { fromPagination: true });
    })
  }

  /**
   * 刷新对应帐套下的机构信息
   * @param key
   */
  const flushOrgList = ({ key }) => {
    QueryOrgByAccountId(key, (res) => {
      GoingUtils.closeLoading();
      if (res) {
        orgTreeList.value = initTreeData(deepClone(res), unref(expandedKeys));
      }
    });
  };

  //查询部门信息
  flusOrgList();
  return {
    total,
    onShowSizeChange,
    pageSize,
    current: currentVal,
    flushOrgList,
    selectOrg,
    searchUserList,
    expandedKeys,
    orgTreeList,
    flusOrgList,
  };
}
